const TypeCampaign = {
    Mix: 1,
    OnlyPublic: 2,
    OnlyEmployee: 3,
    ExternalPayRoll: 4,
};

export default TypeCampaign;